module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-99.630f259b.svg";